<script>
import { defineComponent } from 'vue'
import AgGridMethods from '@/Mixins/SigmaClientNew/AgGridMethods'
import AgGridSearchResultColumns, { TransLinkCellRenderer } from '@/Mixins/SigmaClientNew/AgGridSearchResultColumns'
import { AgGridVue } from 'ag-grid-vue3'

export default defineComponent({
  name: 'SearchResultsAgGrid',

  components: { AgGridVue },

  mixins: [AgGridMethods, AgGridSearchResultColumns],

  props: {
    name: { required: true, type: String },
    iteration: { required: true, type: Number },
    width: { required: true, type: String },
    height: { required: true, type: String },
    classes: { type: String, default: 'ag-theme-balham' },
    rowData: { required: false },
    columns: { type: Array, default: undefined },
    options: { type: Object, default: undefined }
  },

  data () {
    return {
      gridApi: null,
      columnApi: null,
      defaultColDefs: undefined,
      defaultGridOptions: undefined
    }
  },

  computed: {
    columnDefs () {
      return this.columns || this.defaultColDefs
    },
    gridOptions () {
      return this.options || this.defaultGridOptions
    }
  },

  methods: {
    onGridReady (params) {
      this.gridApi = params.api
      this.columnApi = params.api
    },
    onFirstDataRendered (params) {
      this.safeSizeColumnsToFit(params)
    }
  },

  beforeMount () {
    // Columns from mixin. These are shared by the master grid and the
    const baseColumns = [
      this.searchSrcColumn,
      this.searchAccountColumn,
      this.searchDescriptionColumn,
      this.searchVendorColumn,
      this.searchDocColumn,
      this.searchEffectiveDateColumn,
      this.searchStatusColumn,
      this.searchPOColumn,
      this.searchPaymentColumn,
      this.searchAmountColumn
      // this.searchCreatedByColumn,
      // this.searchPostingDateColumn,
      // this.searchModifiedByColumn,
      // this.searchModificationDateColumn
    ]

    // The ID column carries the expand toggle for rows that have dc_lines.
    const masterIdColumn = {
      ...this.searchIdColumn,
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        innerRenderer: TransLinkCellRenderer,
        suppressCount: true
      }
    }

    this.defaultColDefs = [masterIdColumn, ...baseColumns]

    const detailIdColumn = {
      ...this.searchIdColumn,
      cellRendererParams: { useType: true }
    }
    const detailColumns = [detailIdColumn, ...baseColumns]

    this.defaultGridOptions = {
      rowSelection: 'single',
      animateRows: true,
      enableBrowserTooltips: true,
      defaultColDef: {
        resizable: true,
        sortable: true,
        menuTabs: []
      },
      masterDetail: true,
      // Only rows that actually carry dc_lines get an expand toggle.
      isRowMaster: (dataItem) =>
        dataItem ? Array.isArray(dataItem.dc_lines) && dataItem.dc_lines.length > 0 : false,
      detailRowAutoHeight: true,
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: detailColumns,
          defaultColDef: {
            resizable: true,
            sortable: true,
            menuTabs: []
          }
        },
        getDetailRowData: (params) => {
          params.successCallback((params.data && params.data.dc_lines) || [])
        }
      },
      onGridReady: (p) => this.onGridReady(p),
      onFirstDataRendered: (p) => this.onFirstDataRendered(p)
    }
  }
})
</script>

<template>
<div>
  <ag-grid-vue
    style="padding: 5px !important; overflow: auto !important;"
    :name="name"
    :ref="name"
    :class="classes"
    :style="{ width, height }"
    :key="iteration"
    :column-defs="columnDefs"
    :row-data="rowData"
    :grid-options="gridOptions"
  />
</div>
</template>

<style scoped>
/* Tighten the default gap the group cell renderer leaves between the
   expand arrow and the Trans # value on master rows. */
:deep(.ag-group-expanded),
:deep(.ag-group-contracted) {
  margin-right: 4px;
}
:deep(.ag-group-checkbox) {
  display: none;
}
</style>